<template>
    <el-container class="movie-shell">
        <el-header>
            <el-menu
                :default-active="$route.path"
                class="nav-menu"
                mode="horizontal"
                :router="true"
                background-color="#545c64"
                text-color="#fff"
                active-text-color="#ffd04b"
            >
                <el-menu-item
                    :index="item.path"
                    v-for="item in menuList"
                    :key="item.id"
                >
                    <b style="font-size: 28px"> {{ item.name }}</b>
                </el-menu-item>
            </el-menu>
        </el-header>
        <el-main class="movie-main">
            <!-- 类别查询 -->
            <div class="tags-container">
                <div class="tags-line">
                    <div class="tags-title">
                        <i class="iconfont icon-r-find" style="font-size: 28px;"></i><b style="font-size: 20px;"> 类型</b>
                    </div>
                    <div class="category-scroll">
                        <el-radio-group v-model="categoryRadio" class="category-group">
                            <el-radio-button :label="0">全部</el-radio-button>
                            <el-radio-button
                                :label="item.movieCategoryId"
                                v-for="item in categoryList"
                                :key="item.movieCategoryId"
                                >{{ item.movieCategoryName }}</el-radio-button
                            >
                        </el-radio-group>
                    </div>
                </div>
            </div>

            <!-- 按条件排序 -->
            <div class="order-by-container">
                <el-radio-group v-model="orderByColumn" class="sort-radio-group" size="small">
                    <el-radio-button
                        v-for="item in movieSortOptions"
                        :key="item.value"
                        :label="item.value"
                    >
                        {{ item.label }}
                    </el-radio-button>
                </el-radio-group>
            </div>

            <!--      <router-view :movieCategoryId="categoryRadio" :movieAreaId="areaRadio" :movieAgeId="ageRadio" :orderByColumn="orderByColumn"></router-view>-->
            <router-view
                :movieCategoryId="categoryRadio"
                :orderByColumn="orderByColumn"
            ></router-view>
        </el-main>
    </el-container>
</template>

<script>
const {
    movieSortOptions,
    DEFAULT_MOVIE_SORT,
} = require("./movieSortOptions");

export default {
    name: "Movie",
    data() {
        return {
            movieSortOptions,
            menuList: [
                {
                    id: "1",
                    name: "正在热映",
                    path: "/movie/movieOngoing",
                },
                {
                    id: "2",
                    name: "即将上映",
                    path: "/movie/movieUpcoming",
                },
                {
                    id: "3",
                    name: "热播影片",
                    path: "/movie/movieClassics",
                },
            ],
            categoryRadio: 0,
            categoryList: [],
            orderByColumn: DEFAULT_MOVIE_SORT,
        };
    },
    created() {
        this.getCategoryList();
    },
    methods: {
        async getCategoryList() {
            const { data: res } = await axios.get("sysMovieCategory/find");
            if (res.code !== 200)
                return this.$message.error("获取服务器信息失败");
            this.categoryList = res.data;
        },
    },
    watch: {
        $route() {
            //页面发生变化时初始化类别选项
            this.categoryRadio = 0;
            this.orderByColumn = DEFAULT_MOVIE_SORT;
        },
    },
};
</script>

<style scoped>
.el-header {
    padding: 0px;
}

.nav-menu {
    display: flex;
    justify-content: space-around;
}

.el-menu-item {
    font-size: 16px;
}

.el-menu-item:hover {
    color: #ffffff !important;
}

.el-main {
    width: 1200px;
    margin: 0 auto;
}

.tags-container {
    border: solid #eeeeee 1px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.tags-line {
    width: 100%;
    display: flex;
    padding: 10px;
    box-sizing: border-box;
    border-bottom: solid #eeeeee 1px;
}

.tags-line:last-child {
    border-bottom: 0;
}

.tags-title {
    width: 8%;
    height: 24px;
    line-height: 24px;
    float: left;
    color: #999;
    font-size: 26px;
}

.el-radio-group {
    width: 92%;
    margin-left: 20px;
}

.category-scroll {
    width: 92%;
    margin-left: 20px;
}

.category-group {
    width: 100%;
}

.el-radio-button {
    margin-right: 10px;
}

.el-radio-button:last-child {
    margin-right: 0;
}

.el-radio-button >>> .el-radio-button__inner {
    border: solid #eee 0px !important;
    border-radius: 50px !important;
}

.order-by-container {
    margin: 30px 10px 28px 10px;
}

.sort-radio-group {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 10px;
}

.sort-radio-group >>> .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background-color: #ef4238;
    border-color: #ef4238;
    box-shadow: -1px 0 0 0 #ef4238;
}

@media (max-width: 1023px) {
    .movie-main {
        width: auto;
        margin: 0 24px;
    }

    .tags-title {
        width: 72px;
    }

    .el-radio-group {
        width: calc(100% - 92px);
    }

    .category-scroll {
        width: calc(100% - 92px);
    }
}

@media (max-width: 768px) {
    #app.is-mobile-layout .movie-shell .nav-menu {
        justify-content: flex-start;
        overflow-x: auto;
    }

    #app.is-mobile-layout .movie-shell .el-menu-item {
        padding: 0 18px;
    }

    #app.is-mobile-layout .movie-shell .el-menu-item b {
        font-size: 20px !important;
    }

    #app.is-mobile-layout .movie-shell .movie-main {
        width: auto;
        margin: 0;
        padding: 16px;
    }

    #app.is-mobile-layout .movie-shell .tags-line {
        flex-direction: column;
        gap: 12px;
    }

    #app.is-mobile-layout .movie-shell .tags-title {
        width: 100%;
        height: auto;
    }

    #app.is-mobile-layout .movie-shell .category-scroll {
        width: 100%;
        margin-left: 0;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        padding-bottom: 4px;
    }

    #app.is-mobile-layout .movie-shell .category-group {
        width: max-content;
        display: flex;
        flex-wrap: nowrap;
        gap: 8px;
    }

    #app.is-mobile-layout .movie-shell .el-radio-button {
        margin-right: 0;
    }

    #app.is-mobile-layout .movie-shell .category-group >>> .el-radio-button__inner {
        padding: 8px 14px;
        font-size: 14px;
        border-radius: 999px !important;
        white-space: nowrap;
    }

    #app.is-mobile-layout .movie-shell .order-by-container {
        margin: 20px 0 24px 0;
    }

    #app.is-mobile-layout .movie-shell .sort-radio-group {
        display: flex;
        width: 100%;
        gap: 8px;
    }

    #app.is-mobile-layout .movie-shell .sort-radio-group .el-radio-button {
        flex: 1 1 0;
    }

    #app.is-mobile-layout .movie-shell .sort-radio-group >>> .el-radio-button__inner {
        width: 100%;
        padding: 10px 0;
        font-size: 14px;
        border-radius: 999px !important;
    }
}
</style>
